import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { Accordion } from "flowbite-react";
import logo_img from "../assets/img/logo.png";

// Icons
import {
  FaBars,
  FaChevronRight,
  FaExternalLinkAlt,
  FaChevronDown,
} from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";

import { RiArrowDropDownLine } from "react-icons/ri";

/**
 * -------------------------------
 * Menu Data
 * -------------------------------
 * Defines the primary navigation data for both mobile and desktop (MegaMenu).
 */
const menuData = [
  {
    title: "About Us",
    items: [
      {
        title: "Discover About Us",
        links: [
          { text: "Discover AeroAegis", href: "/discover-aeroaegis" },
          { text: "Our Capabilities", href: "/aeroaegis-capabilities" },
        ],
      },
      {
        title: "Our Values & Teams",
        links: [
          { text: "Leadership & Values", href: "/leadership-team" },
          {
            text: "Partnership & Collaborations",
            href: "/partnerships-collaborations",
          },
        ],
      },
      {
        title: "Investor Relations",
        links: [{ text: "Investor Relation", href: "/investor-relations" }],
      },
      {
        title: "Careers",
        links: [{ text: "Join Our Team", href: "/careers" }],
      },
    ],
    image: {
      src: "https://images.unsplash.com/photo-1551434678-e076c223a692",
      alt: "About Us",
      title: "About Us",
      description: "Get to know our mission, vision, and values",
    },
  },
  {
    title: "Products & Platforms",
    items: [
      {
        title: "Cloud Transformation & Resilience",
        links: [
          { text: "Maturity Spectrum 360", href: "/maturity-spectrum-360" },
          { text: "SmartChaos Lab", href: "/smartchaos-lab" },
        ],
      },
      {
        title: "AI-Driven Insights & Automation",
        items: [
          {
            title: "AeroGenix",
            links: [
              {
                text: `AeroGenix AI`,
                // (AI-powered automation & intelligence)`,
                href: "/aerogenix-ai",
              },
              {
                text: `AeroGenix GPT`,
                // (Enterprise AI for decision support & automation)`,
                href: "/aerogenix-gpt",
              },
            ],
          },
        ],
        links: [
          { text: "AeroPulse AI", href: "/aeropulse-ai" },
          { text: "AeroInfra Vue", href: "/infra-vue" },
        ],
      },
      {
        title: "Industrial IoT & Edge Intelligence",
        links: [{ text: "AeroEdge IIoT", href: "/aeroedge-iiot" }],
      },
      {
        title: "Products",
        links: [{ text: "View all Products", href: "/products" }],
      },
    ],
    image: {
      src: "https://images.unsplash.com/photo-1518770660439-4636190af475",
      alt: "Cloud Solutions",
      title: "Products & Platforms",
      description: "Discover our cutting-edge products",
      link: "/products",
    },
  },
  {
    title: "Engineering Excellence",
    items: [
      {
        title: "Engineering Excellence",
        links: [
          {
            text: "R&D Focus",
            href: "/engineering-excellence/research-and-development-focus",
          },
          {
            text: "Product Engineering Processes",
            href: "/engineering-excellence/product-engineering",
          },
          {
            text: "IP Development",
            href: "/engineering-excellence/ip-development",
          },
          {
            text: "Centers of Excellence (COEs)",
            href: "/engineering-excellence/center-of-excellence",
          },
        ],
      },
    ],
    image: {
      src: "https://images.unsplash.com/photo-1498050108023-c5249f4df085",
      alt: "Solutions",
      title: "Engineering Excellence",
      description: "Tailored solutions for your unique engineering needs",
    },
  },
  {
    title: "Services",
    items: [
      {
        title: "Product Engineering",
        links: [
          {
            text: "Custom Product Development",
            href: "/services/product-engineering/custom-product-development",
          },
          {
            text: "Cloud-Native Product Engineering",
            href: "/services/product-engineering/cloud-native-product-engineering",
          },
          {
            text: "AI/ML-Embedded Product Solutions",
            href: "/services/product-engineering/embedded-product-solutions",
          },
          {
            text: "IoT-Enabled Product Engineering",
            href: "/services/product-engineering/iot-enabled-product-engineering",
          },
        ],
      },
      {
        title: "Strategic Consulting",
        links: [
          {
            text: "Digital Transformation Consulting",
            href: "/services/strategic-consulting/digital-transformation",
          },
          {
            text: "AI and Data Strategy Consulting",
            href: "/services/strategic-consulting/ai-and-data",
          },
          {
            text: "Cloud Strategy & Migration Consulting",
            href: "/services/strategic-consulting/cloud-migration",
          },
          {
            text: "Blockchain Advisory Services",
            href: "/services/strategic-consulting/blockchain-advisory",
          },
        ],
      },
      {
        title: "System Integration",
        links: [
          {
            text: "Enterprise Application Integration",
            href: "/services/system-integration/enterprise-application-integration",
          },
          {
            text: "Cloud Migration and Integration",
            href: "/services/system-integration/cloud-migration-integration",
          },
          {
            text: "Automation & RPA Solutions",
            href: "/services/system-integration/system-rpa-solutions",
          },
          {
            text: "API and Microservices Integration",
            href: "/services/system-integration/api-microservices-integration",
          },
        ],
      },
      {
        title: "Operational Excellence",
        links: [
          {
            text: "DevOps & Site Reliability Engineering (SRE)",
            href: "/services/operational-excellence/devops-and-sre",
          },
          {
            text: "Chaos Engineering Services",
            href: "/services/operational-excellence/chaos-engineering-solutions",
          },
          {
            text: "Performance Optimization",
            href: "/services/operational-excellence/performance-optimization",
          },
          {
            text: "Managed Services & Support",
            href: "/services/operational-excellence/managed-service-support",
          },
        ],
      },
      {
        title: "AI and Data",
        links: [
          {
            text: "AI/ML Model Development",
            href: "/services/ai-data/ai-ml-model-development",
          },
          {
            text: "Data Analytics & Insights",
            href: "/services/ai-data/data-analytics-insights",
          },
          {
            text: "Data Engineering Services",
            href: "/services/ai-data/data-engineering",
          },
          {
            text: "Generative AI Solutions",
            href: "/services/ai-data/generative-ai-solutions",
          },
        ],
      },
      {
        title: "IoT & Edge Solutions",
        links: [
          {
            text: "Smart Infrastructure Deployment",
            href: "/services/iot-edge-solutions/smart-infra-deployment",
          },
          {
            text: "Edge Computing Integration",
            href: "/services/iot-edge-solutions/edge-computing-integration",
          },
          {
            text: "Predictive Maintenance Services",
            href: "/services/iot-edge-solutions/predictive-maintainance-service",
          },
          {
            text: "Digital Twin Solutions",
            href: "/services/iot-edge-solutions/digital-twin-solutions",
          },
        ],
      },
      {
        title: "IAM & Security Services",
        links: [
          {
            text: "Identity and Access Management",
            href: "/services/iam-security/identity-access-management",
          },
          {
            text: "Privileged Access Management (PAM)",
            href: "/services/iam-security/privileged-access-management",
          },
          {
            text: "Cloud IAM Solutions",
            href: "/services/iam-security/cloud-iam-solutions",
          },
          {
            text: "Zero Trust Security Architecture",
            href: "/services/iam-security/zero-trust-security",
          },
          {
            text: "Regulatory Compliance and Audit Readiness",
            href: "/services/iam-security/regulatory-compliance",
          },
        ],
      },
    ],
    image: {
      src: "https://images.unsplash.com/photo-1521791136064-7986c2920216",
      alt: "Our Services",
      title: "Expert Services",
      description: "End-to-end solutions for your business needs",
    },
  },
  {
    title: "Industries",
    items: [
      {
        title: "Industries",
        links: [
          { text: "Healthcare", href: "/industries/healthcare" },
          { text: " Manufacturing", href: "/industries/manufacturing" },
          {
            text: "Logistics & Supply Chain",
            href: "/industries/logistics-and-supplychain",
          },
          { text: "Finance & Banking", href: "/industries/finance-banking" },
          { text: "Retail & E-Commerce", href: "/industries/retail-ecommerce" },
          { text: "Aerospace", href: "/industries/aerospace" },
          {
            text: "Telecom & Networks",
            href: "/industries/telecom-and-network",
          },
          { text: "Energy & Utilities", href: "/industries/energy-utilities" },
          {
            text: "Pharmaceuticals & Life Sciences",
            href: "/industries/pharmaceuticals-life-sciences",
          },
          { text: "Automotive", href: "/industries/automotive" },
        ],
      },
    ],
    image: {
      src: "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?q=80&w=1473&auto=format&fit=crop",
      alt: "Industries",
      title: "Industry Expertise",
      description: "Explore tailored solutions for a variety of industries",
    },
  },
  {
    title: "Resources",
    items: [
      {
        title: "Resources",
        links: [
          { text: "Blogs", href: "/blogs" },
          { text: "Whitepapers", href: "/white-papers" },
          { text: "Case Studies", href: "/case-studies" },
        ],
      },
    ],
    image: {
      src: "https://images.unsplash.com/photo-1519337265831-281ec6cc8514",
      alt: "Resources",
      title: "Explore Resources",
      description: "Access our knowledge base to stay informed",
    },
  },
];

/* -------------------------------------------------------------------------- */
/*                              REUSABLE COMPONENTS                           */
/* -------------------------------------------------------------------------- */

/**
 * MenuItem (Mobile)
 * Renders a single item in the Mobile Menu with optional sub-items or links.
 */
const MenuItem = ({ item, onNavigate }) => {
  const hasSubItems = item.items && item.items.length > 0;
  const hasLinks = item.links && item.links.length > 0;
  const hasSingleSubmenu = hasSubItems && item.items.length === 1;

  console.log(hasSubItems, "subitems");
  const handleClick = () => {
    // if (hasSingleSubmenu) {
    //   onNavigate(item.items[0]);
    // } else {
    //   onNavigate(item);
    // }
    if (hasSingleSubmenu) {
      onNavigate(item); // ✅ Show the full submenu instead of auto-selecting the first item
    } else {
      onNavigate(item);
    }
  };

  return (
    <div className="py-3">
      <div
        className="flex items-center justify-between cursor-pointer text-md"
        onClick={handleClick}
      >
        <span className="font-semibold">{item.title}</span>
        {(hasSubItems || hasLinks) && (
          <FaChevronRight className="text-gray-600" />
        )}
      </div>
    </div>
  );
};

/**
 * MobileMenu
 * Handles the rendering of the site navigation on mobile devices.
 */
const MobileMenu = ({ menuData, isSticky, location }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [menuStack, setMenuStack] = useState([
    { title: "Menu", items: menuData },
  ]);

  // Toggle the mobile menu open/close
  const toggleMenu = () => setIsMenuOpen((prev) => !prev);
  // In MobileMenu
  const navigateToSubMenu = (item) => {
    // 1) Special logic: If item is "Engineering Excellence", "Industries", or "Resources",
    //    and it has exactly 1 sub-item with the same title, then flatten it:
    if (
      ["Engineering Excellence", "Industries", "Resources"].includes(item.title) &&
      item.items?.length === 1 &&
      item.items[0].title === item.title
    ) {
      // item.items[0] is that "duplicate" sub-item, so use *its* links/items directly
      const sub = item.items[0];
      setMenuStack((prevStack) => [
        ...prevStack,
        {
          title: item.title,       // Keep the top-level title
          items: sub.items || [],  // Flatten sub-items
          links: sub.links || [],  // Flatten sub-links
        },
      ]);
    } 
    else if (item.items || item.links) {
      setMenuStack((prevStack) => [
        ...prevStack,
        {
          title: item.title,
          items: item.items || [],
          links: item.links || [],
        },
      ]);
    }
  };


  // Step back to previous menu level
  const navigateBack = () => {
    setMenuStack((prevStack) =>
      prevStack.length > 1 ? prevStack.slice(0, -1) : prevStack
    );
  };

  const currentMenu = menuStack[menuStack.length - 1] || menuData[0];
  console.log(currentMenu, "CurrentMenu");
  return (
    <div className="relative">
      {/* Hamburger / Close Icon */}
      <button
        onClick={toggleMenu}
        className={`text-2xl p-2 focus:outline-none relative z-[10000] ${
          location?.pathname === "/" && !isSticky
            ? isMenuOpen
              ? "text-gray-800 hover:text-blue-900"
              : "text-white"
            : "text-gray-800 hover:text-blue-900"
        }`}
      >
        {isMenuOpen ? <FaXmark size={24} /> : <FaBars size={24} />}
      </button>

      {/* Full-Screen Mobile Menu Overlay */}
      {isMenuOpen && (
        <div className="fixed inset-0 bg-white z-[9999] h-[100dvh] overflow-y-auto p-4">
          <div className="h-full flex flex-col">
            <div className="flex-grow">
              <div className="mt-16">
                {menuStack.length > 1 && (
                  <button
                    onClick={navigateBack}
                    className="mb-4 flex items-center text-blue-600 absolute top-2 left-2 text-lg"
                  >
                    <FaChevronRight className="transform rotate-180 mr-2" />
                    Back
                  </button>
                )}
                <h2 className="text-3xl font-bold mb-4">{currentMenu.title}</h2>

                {currentMenu.items &&
                  currentMenu.items.length > 0 &&
                  currentMenu.items.map((item, index) => (
                    <MenuItem
                      key={index}
                      item={item}
                      onNavigate={navigateToSubMenu}
                    />
                  ))}

                {currentMenu.links && currentMenu.links.length > 0 && (
                  <div>
                    {currentMenu.links.map((link, index) => (
                      <Link
                        key={index}
                        to={link.href}
                        className="block py-2 text-blue-600 hover:underline flex items-center justify-between"
                        onClick={() => {
                          setIsMenuOpen(false);
                          setMenuStack([{ title: "Menu", items: menuData }]);
                        }}
                      >
                        {link.text}
                        <FaExternalLinkAlt className="text-gray-600" />
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Contact Us Button */}
            <div className="flex justify-center">
              <Link
                to="/contact-us"
                className="inline-flex items-center justify-center h-12 px-6 font-medium tracking-wide text-white transition duration-200 rounded shadow-md bg-[#252f80] hover:bg-slate-800 focus:shadow-outline focus:outline-none"
                onClick={() => {
                  setIsMenuOpen(false);
                  setMenuStack([{ title: "Menu", items: menuData }]);
                }}
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

/**
 * MegaMenuItem (Desktop)
 * Responsible for rendering a top-level desktop menu item (with dropdown/mega menu).
 */
const MegaMenuItem = ({ title, items, image, isSticky, location }) => {
  const menuRef = useRef(null);
  const [forceHide, setForceHide] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [scrollContainer, setScrollContainer] = useState(null);
  const [isAtBottom, setIsAtBottom] = useState(false);
  const hiddenFocusRef = useRef(null);

  // Detect if the device supports hover (i.e., not a mobile/touch device)
  const isTouch =
    window.matchMedia && window.matchMedia("(hover: none)").matches;

  /**
   * Monitors scrolling to decide whether to show or hide the "Scroll Down" button
   */
  useEffect(() => {
    if (!scrollContainer) return;

    const handleScroll = () => {
      const { scrollTop, clientHeight, scrollHeight } = scrollContainer;
      const atBottom = scrollTop + clientHeight >= scrollHeight - 50;
      setIsAtBottom(atBottom);
    };

    scrollContainer.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      scrollContainer.removeEventListener("scroll", handleScroll);
    };
  }, [scrollContainer]);

  /**
   * Closes dropdown on route change or when switching from desktop to mobile, etc.
   */
  useEffect(() => {
    if (isTouch) {
      setDropdownOpen(false);
    } else if (menuRef.current) {
      setForceHide(false);
      // Fire mouseleave to close
      menuRef.current.dispatchEvent(
        new MouseEvent("mouseleave", { bubbles: true })
      );
    }
  }, [location.pathname, isTouch]);

  /**
   * Closes dropdown if user clicks/taps outside of it
   */
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        if (isTouch) {
          setDropdownOpen(false);
        } else {
          // Fire mouseleave to close
          menuRef.current.dispatchEvent(
            new MouseEvent("mouseleave", { bubbles: true })
          );
        }
      }
    };

    document.addEventListener("click", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isTouch]);

  /**
   * Cleanup function for forced closures on link clicks
   */
  const handleClickLink = () => {
    // Force focus changes to ensure closure in some edge browsers
    if (
      document.activeElement &&
      typeof document.activeElement.blur === "function"
    ) {
      document.activeElement.blur();
    }
    if (hiddenFocusRef.current) {
      hiddenFocusRef.current.focus();
      setTimeout(() => hiddenFocusRef.current.blur(), 50);
    }
    document.body.click();
    hiddenFocusRef.current.click();
    setTimeout(() => {
      document.body.dispatchEvent(
        new MouseEvent("mouseover", { bubbles: true })
      );
    }, 100);
  };

  const [collapseAccordion, setCollapseAccordion] = useState(false);

  useEffect(() => {
    if (!dropdownOpen) {
      setCollapseAccordion(true); // Ensure accordion closes when menu closes
    }
  }, [dropdownOpen]);
  return (
    <div
      ref={menuRef}
      className="group"
      onMouseLeave={() => setCollapseAccordion(true)}
      // onMouseEnter={() => setCollapseAccordion(false)}
    >
      {/* Hidden focusable element to help "close" the dropdown. */}
      <button
        ref={hiddenFocusRef}
        style={{
          position: "absolute",
          opacity: 0,
          pointerEvents: "none",
          zIndex: -1,
        }}
      />

      {/* Menu Title Button */}
      <button
        onClick={isTouch ? () => setDropdownOpen((prev) => !prev) : undefined}
        className={`
          flex items-center space-x-1 py-2 font-medium transition-colors
          ${
            location?.pathname === "/" && !isSticky
              ? "text-white hover:text-purple-100"
              : "text-gray-700 hover:text-blue-900"
          }
        `}
      >
        <span>{title}</span>
        <RiArrowDropDownLine className="h-6 w-6" />
      </button>

      {/* Mega Menu Dropdown (Desktop) / Toggle (Mobile) */}
      {(isTouch || (!isTouch && !forceHide)) && (
        <div
          ref={setScrollContainer}
          className={`
            max-h-[500px] overflow-auto overflow-x-hidden absolute left-1/2 -translate-x-1/2 top-[110%]
            min-w-full w-auto rounded-lg bg-white shadow-xl transition-all duration-300 z-[9999] transform
            ${
              isTouch
                ? dropdownOpen
                  ? "opacity-100 visible translate-y-0"
                  : "opacity-0 invisible translate-y-2"
                : `opacity-0 invisible group-hover:opacity-100 group-focus:opacity-100
                   group-focus:visible group-hover:visible translate-y-2
                   group-focus:translate-y-0 group-hover:translate-y-0`
            }
          `}
        >
          <div className="mx-auto py-8 px-4">
            <div className="flex gap-4">
              {/* Left Part: Nested Menu Items */}
              <div className="flex-grow">
                <div
                  className={`${
                    items?.length <= 1
                      ? "grid-cols-2 gap-6"
                      : items?.length === 2
                      ? "grid grid-cols-2 gap-8"
                      : "grid grid-cols-3 gap-5"
                  }`}
                >
                  {items &&
                    items.map((section, idx) => (
                      <div key={idx} className="space-y-3">
                        <h3 className="font-semibold px-2 text-gray-900 text-lg border-b border-gray-100 pb-3">
                          {section.title}
                        </h3>

                        {/* If this section has nested items, render using Accordion */}
                        {section.items && (
                          <div>
                            <Accordion
                              key={collapseAccordion ? "collapsed" : "open"}
                              className="!border-0 !shadow-none !p-0 !ring-0  bg-transparent  focus:!border-0 focus:!ring-0 "
                              collapseAll={collapseAccordion} // This will close the accordion
                              alwaysOpen={false}
                            >
                              {section.items.map((subItem, subIdx) => (
                                <Accordion.Panel
                                  key={subIdx}
                                  className="!border-0 !shadow-none !ring-0"
                                >
                                  <Accordion.Title
                                    className="!border-0 !shadow-none !font-weight[400] text-[16px] !text-gray-600 !ring-0 !px-2 !py-1.5 hover:!text-blue-900 hover:bg-gray-200 focus:bg-gray-200  rounded-md cursor-pointer focus:text-blue-900"
                                    // onMouseLeave={() => setDropdownOpen(false)}
                                    onMouseEnter={() =>
                                      setCollapseAccordion(false)
                                    }
                                  >
                                    {subItem.title}
                                  </Accordion.Title>
                                  <Accordion.Content className="!border-0 !shadow-none">
                                    {subItem.links && (
                                      <ul className="space-y-1 text-base">
                                        {subItem.links.map((link, linkIdx) => (
                                          <li key={linkIdx}>
                                            {console.log(link, "link")}
                                            <Link
                                              to={link.href}
                                              className="grid grid-cols-[1fr_auto] gap-1 items-center text-gray-600 hover:text-blue-900 hover:bg-gray-200 px-2 pr-2 rounded-md cursor-pointer group py-1 overflow-hidden"
                                              onClick={() => {
                                                handleClickLink();
                                                if (isTouch) {
                                                  setDropdownOpen(false);
                                                  scrollContainer?.scrollTo({
                                                    top: 0,
                                                    left: 0,
                                                    behavior: "instant",
                                                  });
                                                } else if (menuRef.current) {
                                                  setForceHide(true);
                                                  menuRef.current.dispatchEvent(
                                                    new MouseEvent(
                                                      "mouseleave",
                                                      {
                                                        bubbles: true,
                                                      }
                                                    )
                                                  );
                                                  menuRef.current.dispatchEvent(
                                                    new MouseEvent("mouseout", {
                                                      bubbles: true,
                                                    })
                                                  );
                                                  setTimeout(
                                                    () => setForceHide(false),
                                                    200
                                                  );
                                                }
                                              }}
                                            >
                                              <div className="overflow-hidden">
                                                <span className="inline-block transition-transform duration-200 whitespace-pre-line leading-normal">
                                                  {link.text}
                                                </span>
                                              </div>
                                              <FaExternalLinkAlt className="h-4 w-4 opacity-100" />
                                            </Link>
                                          </li>
                                        ))}
                                      </ul>
                                    )}
                                  </Accordion.Content>
                                </Accordion.Panel>
                              ))}
                            </Accordion>
                          </div>
                        )}

                        {/* Render direct links if present */}
                        {section.links && (
                          <ul className="space-y-2 text-base">
                            {section.links.map((link, linkIdx) => (
                              <li key={linkIdx}>
                                {console.log(link, "LINK")}
                                <Link
                                  to={link.href}
                                  className="grid grid-cols-[1fr_auto] gap-2 items-center text-gray-600 hover:text-blue-900 hover:bg-gray-200 px-2 pr-2 rounded-md cursor-pointer group py-1.5 overflow-hidden"
                                  onClick={() => {
                                    handleClickLink();
                                    if (isTouch) {
                                      setDropdownOpen(false);
                                      scrollContainer?.scrollTo({
                                        top: 0,
                                        left: 0,
                                        behavior: "instant",
                                      });
                                    } else if (menuRef.current) {
                                      setForceHide(true);
                                      menuRef.current.dispatchEvent(
                                        new MouseEvent("mouseleave", {
                                          bubbles: true,
                                        })
                                      );
                                      menuRef.current.dispatchEvent(
                                        new MouseEvent("mouseout", {
                                          bubbles: true,
                                        })
                                      );
                                      setTimeout(
                                        () => setForceHide(false),
                                        200
                                      );
                                    }
                                  }}
                                >
                                  <div className="overflow-hidden">
                                    <span className="inline-block transition-transform duration-200 whitespace-pre-line leading-normal">
                                      {link.text}
                                    </span>
                                  </div>
                                  <FaExternalLinkAlt className="h-4 w-4 opacity-100" />
                                </Link>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    ))}
                </div>
              </div>

              {/* Optional Image Card */}
              {image && (
                <Link
                  to={image.link || "#"}
                  className="self-stretch sticky top-0"
                  onClick={() => {
                    handleClickLink();
                    if (isTouch) {
                      setDropdownOpen(false);
                    } else if (menuRef.current) {
                      setForceHide(true);
                      menuRef.current.dispatchEvent(
                        new MouseEvent("mouseleave", { bubbles: true })
                      );
                      menuRef.current.dispatchEvent(
                        new MouseEvent("mouseout", { bubbles: true })
                      );
                      setTimeout(() => setForceHide(false), 200);
                    }
                  }}
                >
                  <div className="h-full max-h-[428px] xl:w-[350px] lg:w-[250px] sticky top-5">
                    <div className="relative h-full w-full rounded-xl overflow-hidden shadow-lg">
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="object-cover h-full w-full transform hover:scale-105 transition-transform duration-700"
                      />
                      <div className="absolute inset-0 bg-gradient-to-tr from-blue-900/90 to-transparent">
                        <div className="absolute bottom-0 left-0 p-8 h-full text-white">
                          <h4 className="text-2xl font-bold">{image.title}</h4>
                          <p className="mt-3 text-gray-100">
                            {image.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              )}
            </div>
          </div>

          {/* Sticky Scroll-Down Button (for Services / Industries) */}
          {(title.includes("Services") || title.includes("Industries")) && (
            <div
              className={`
                flex justify-center sticky w-full bottom-0 pointer-events-none 
                overflow-hidden h-[40px] bg-white ${
                  !isAtBottom ? "block" : "hidden"
                }
              `}
            >
              <button
                className="w-full h-full flex items-center justify-center pointer-events-auto"
                onClick={() => {
                  scrollContainer?.scrollBy({ top: 50, behavior: "smooth" });
                }}
              >
                <FaChevronDown
                  className={`my-2 -translate-x-1/2 text-center text-blue-800 text-2xl ${
                    !isAtBottom ? "animate-bounce" : ""
                  }`}
                />
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

/**
 * Header
 * Main site header that combines both Mobile and Desktop (MegaMenu) navigation.
 */
export default function Header() {
  const [isSticky, setIsSticky] = useState(false);
  const location = useLocation();

  // Toggle sticky header on scroll
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Choose header styling based on scroll or path
  const headerClass = isSticky
    ? "fixed top-0 left-0 w-full bg-base-100/80 backdrop-blur shadow-md z-50 transition-all duration-300 ease-in-out transform translate-y-0"
    : location?.pathname === "/"
    ? "bg-transparent backdrop-blur z-50 relative"
    : "";

  return (
    <div className={headerClass}>
      <div className="px-4 py-1 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-2">
        <div className="relative flex items-center w-full justify-between">
          {/* Logo */}
          <Link to="/">
            <img
              src={logo_img}
              className="w-24 lg:w-24 xl:w-36"
              alt="AeroAegis Logo"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-4 text-sm xl:text-base xl:space-x-8 overflow-hidden">
            {menuData.map((item, index) => (
              <MegaMenuItem
                key={index}
                title={item.title}
                items={item.items}
                image={item.image}
                isSticky={isSticky}
                location={location}
              />
            ))}
          </nav>

          {/* Desktop Contact Us Button */}
          <div className="hidden lg:flex items-center space-x-8">
            <Link
              to="/contact-us"
              className="inline-flex items-center justify-center h-12 xl:h-11 text-sm xl:text-base px-4 xl:px-6 font-medium tracking-wide text-white transition duration-200 rounded shadow-md bg-[#252f80] hover:bg-slate-800 focus:shadow-outline focus:outline-none"
            >
              Contact Us
            </Link>
          </div>

          {/* Mobile Navigation */}
          <div className="lg:hidden">
            <MobileMenu
              menuData={menuData}
              isSticky={isSticky}
              location={location}
            />
          </div>
        </div>
      </div>
    </div>
  );
}